const { createMonitor, getDefaultEnvironment } = require('@blaze-cms/core-monitors');
const tracer = require('dd-trace');
const {
  env: { isEnvTrue }
} = require('@blaze-cms/utils');

const { BLAZE_DATADOG_ENVIRONMENT } = require('../constants');

const createDataDogApm = ({ options: { services = '' } = {} } = {}) => {
  const getEnvironment = () => getDefaultEnvironment(BLAZE_DATADOG_ENVIRONMENT);

  const isConfigured = () => isEnvTrue('BLAZE_DATADOG_APM_ACTIVE');

  const setup = project => {
    if (!isActive()) return;

    tracer.init();
    if (services) {
      const allServices = services.split(',');
      allServices.forEach(serviceName => {
        tracer.use(serviceName, {
          service: serviceName
        });
      });
    }
    addTagToActiveCurrentSpan('project', project);
    addTagToActiveCurrentSpan('environment', getEnvironment());
  };

  // Tags can be assigned to existing active span or a child span can be created and tags can be assigned to the new span.
  // As we are using out of the box services to start with, we don't need setting up specific span util
  // we intend to monitor trace for specific part of the code. Instructions for custom instrumentation for
  // spans are in NodeJS Custom Instrumentation are in https://docs.datadoghq.com/tracing/custom_instrumentation/nodejs/?tab=synchronous#accessing-active-spans
  // and https://datadoghq.dev/dd-trace-js/#scope-manager .
  const addTagToActiveCurrentSpan = (key, value) => {
    const span = tracer.scope().active();
    if (span && value) span.setTag(key, value);
  };

  // Log Management needs to be activated separately.
  // Ref: https://docs.datadoghq.com/tracing/connect_logs_and_traces/nodejs/
  // We need this method as a placeholder for core monitor activity
  const log = (data = {}) => {
    // This is intentional placeholder
  };

  const isActive = () => isConfigured(); // Placeholder. Paid plugins can be made inactive after configuration.

  return createMonitor({
    getEnvironment,
    isConfigured,
    setup,
    addTagToActiveCurrentSpan,
    log,
    isActive
  });
};

module.exports = createDataDogApm;
